import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import type { CallLog } from '@frontend/api-phone-calls';
import { ChipVariants } from '@frontend/design-system';
import { RecentCallRecord } from './types';

/**
 * @deprecated - Please use `getFullName` from `@frontend/name` instead.
 */
export const getFullName = (firstName?: string, lastName?: string, defaultValue = '') => {
  if (firstName || lastName) {
    return `${firstName || ''} ${lastName || ''}`.trim();
  }
  return defaultValue || '';
};

export const getOfficeUser = (callInfo: HydratedCallRecord) => {
  const { user } = callInfo;
  const fullName = getFullName(user?.firstName, user?.lastName, '--');
  return fullName;
};

export const getStatusChipColor = (status: CallLog['Status']): ChipVariants => {
  switch (status) {
    case 'abandoned':
      return 'warn';
    case 'missed':
      return 'critical';
    case 'answered':
      return 'primary';
    case 'forwarded':
      return 'eggplant';
    default:
      return 'outline';
  }
};

export const getRecentCallsUniqueKey = (row: RecentCallRecord) => row.id || `${row.channelId}-${row.locationId}`;
